




















import { Component, Prop, Vue, Watch } from "vue-property-decorator";

export interface TextTemplateFormData {
  id: string;
  text: string;
}

@Component({})
export default class TextTemplateForm extends Vue {
  @Prop({ type: Object }) defaultValues!: TextTemplateFormData;

  values: TextTemplateFormData = {
    id: "",
    text: ""
  };

  @Watch("defaultValues", { immediate: true })
  onDefaultValuesChanged(values: TextTemplateFormData) {
    this.values = { ...values };
  }

  submit() {
    this.$emit("submit", this.values);
  }

  cancel() {
    this.$emit("cancel");
  }
}
